import React, { PureComponent } from 'react';
import { withRouter } from 'react-router';
import { isMobileOnly } from 'react-device-detect';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { GAME } from 'utils/defines';

const styles = isMobileOnly ? require('./assets/mobile.scss').default : require('./assets/desktop.scss').default;

const cx = classNames.bind(styles);

const icon = {
  Play: require('./assets/play.svg').default,
  Rules: require('./assets/rules.svg').default,
  Fairness: require('./assets/fairness.svg').default,
};

function Menu({
  background, name, to, pathname,
}) {
  return (
    <li style={{ background: isMobileOnly ? background : null }}>
      <Link className={cx({ on: to === pathname })} to={to}>
        {isMobileOnly && <img src={icon[name]} className="layer" alt={name} />}
        <p className={cx('bold')}>{name}</p>
      </Link>
    </li>
  );
}

Menu.propTypes = {
  background: PropTypes.string,
  name: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  pathname: PropTypes.string.isRequired,
};

Menu.defaultProps = {
  background: null,
};

@connect(
  state => ({
    [GAME._BITTO]: { title: 'BITTO', path: 'bitto' },
    [GAME._TURTLE_RACE]: { title: 'TURTLE RACE', path: 'turtlerace' },
    [GAME._LADDER_GAME]: { title: 'LADDER GAME', path: 'laddergame' },
    [GAME._BACCARAT]: { title: 'BACCARAT', path: 'baccarat' },
  }[state.info.game]),
  {}
)
@withRouter
class GamesHeader extends PureComponent {
  static propTypes = {
    location: PropTypes.objectOf(PropTypes.any).isRequired,
    path: PropTypes.string,
  };

  static defaultProps = {
    path: null,
  };

  componentDidMount() {
    window.addEventListener('scroll', this.handleClickClose);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleClickClose);
  }

  handleClickClose = () => {
    this.setState({ open: false });
  };

  handleClickArrow = () => {
    const { open } = this.state;
    this.setState({ open: !open });
  };

  render() {
    const { location, path } = this.props;

    return (
      <div className={cx(styles.header)}>
        <nav>
          <ul>
            <Menu name={isMobileOnly ? 'Play' : 'PLAY'} to={`/games/${path}/`} pathname={location.pathname} />
            <Menu name={isMobileOnly ? 'Rules' : 'RULES'} to={`/games/${path}/rules/`} pathname={location.pathname} />
            <Menu
              name={isMobileOnly ? 'Fairness' : 'FAIRNESS'}
              to={`/games/${path}/fairness/`}
              pathname={location.pathname}
            />
          </ul>
        </nav>
      </div>
    );
  }
}

export default GamesHeader;
